import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, Validators, FormGroup, FormArray } from '@angular/forms';

import { EncuestaService } from '../../../../src/app/services/encuesta.service';  
import { Pregunta } from '../../../../src/app/models/pregunta.model';    

@Component({
  selector: 'app-formulario-editar-pregunta',
  templateUrl: './formulario-editar-pregunta.component.html',
  styleUrls: ['./formulario-editar-pregunta.component.css']
})
export class FormularioEditarPreguntaComponent implements OnInit {

  private preguntaID = "";
  public formSubmitted = false;
  public preguntaForm = this.fb.group({
    orden:        ['' , [ Validators.required ] ],
    categoria:     ['' , [ Validators.required ] ],
    pregunta:     ['' , [ Validators.required ] ],
    duracion:     ['' , [ Validators.required ] ],
    respuesta:    ['', Validators.required ],
    respuestas:   this.fb.array([])
  } );

  constructor(
    private router: Router,
    private encuestaService: EncuestaService,
    private fb: FormBuilder, 
    private route: ActivatedRoute,
  ) { }

  get respuestas(){
    return this.preguntaForm.get('respuestas') as FormArray;
  }

  async cargarDataFormulario(respuesta: Pregunta){


    this.preguntaForm.reset({
      orden: respuesta.orden,
      categoria: respuesta.categoria,
      pregunta: respuesta.pregunta,
      duracion: respuesta.duracion,
      respuesta: respuesta.respuesta,
    });
    await [...respuesta.respuestas].forEach( valor => this.respuestas.push( this.fb.control(valor)));
     
    //this.preguntaForm.controls['respuesta'].setValue(respuesta.respuesta); 
  }

  ngOnInit(): void {
    this.preguntaID = this.route.snapshot.paramMap.get('id'); 

    this.encuestaService.getPregunta( this.preguntaID ).subscribe( resp => {
      this.cargarDataFormulario( resp );
    }, err => {
      console.log("Error", err.error);  
    }); ;

    
    
    
  }
  actualizarPregunta(){
    console.log("Actualizar pregunta");
    this.formSubmitted = true;
    console.log( this.preguntaForm.value );

    if ( this.preguntaForm.invalid ) {
      console.log("Form invalid");
      return;
    }
    this.encuestaService.actualizarPregunta( this.preguntaID, this.preguntaForm.value ).subscribe( resp => {
      console.log(resp); 
      if( resp.ok ){
         alert("Correcto");
      }else{
        alert("Error");
      } 
      this.router.navigate(['/dashboard/listar-preguntas']); 
    }, err => {
      console.log("Error", err.error);  
    }); 
  }

  campoNoValido( campo: string ): boolean {
    
    if ( this.preguntaForm.get(campo).invalid && this.formSubmitted ) {
      return true;
    } else {
      return false;
    }

  }

  agregarRespuesta(){
    this.respuestas.push( this.fb.control('', Validators.required) )
  }

  quitarRespuesta(i: number){
    this.respuestas.removeAt(i);
  }
}

